import axios from 'axios';
import AuthService from './AuthService';

const BASE = process.env.REACT_APP_API_URL;
const hdrs = () => ({ headers: { Authorization: `Bearer ${AuthService.getToken()}` } });
const unwrap = (d) => (Array.isArray(d) ? d : d?.$values ?? []);

const BuilderService = {
  getByClientId: (clientId) =>
    axios.get(`${BASE}/Builder/ByClient/${clientId}`, hdrs()).then((r) => unwrap(r.data)),

  getById: (id) => axios.get(`${BASE}/Builder/${id}`, hdrs()).then((r) => r.data),

  create: (dto) => axios.post(`${BASE}/Builder/Create`, dto, hdrs()).then((r) => r.data),

  update: (dto) => axios.put(`${BASE}/Builder/Update`, dto, hdrs()).then((r) => r.data),

  delete: (id) => axios.delete(`${BASE}/Builder/Delete/${id}`, hdrs()).then((r) => r.data),
};

export default BuilderService;
